function initJobFilters() {
	$('.job__filter-container select').on('change', function(e) {
		getJobCurrentFilter();
	});
}

var getJobCurrentFilter = function() {
	var currentCat  = $('.job__cat_filter select').val();
	var currentCity = $('.job__city_filter select').val();

	//console.log( 'filtre actif > ' + currentCat + " - " + currentCity);
	$('.job--no-result').addClass('hidden');

	if ( currentCat == 'all' && currentCity == 'all' ) {
		$('.job').removeClass('hidden');
		$('.job--no-result').addClass('hidden');
		return;

	} else {

		$('.job').addClass('hidden');

		var itemCat  = "";
		var itemCity = "";
		var isFull   = false;

		$('.job').each( function(index) {
			itemCat  = $(this).data('cat');
			itemCity = $(this).data('city');

			console.log( index + " > " + itemCat + " - " + itemCity );

			if ( ( itemCat == currentCat || currentCat == 'all' ) && ( itemCity == currentCity ||currentCity == 'all' ) ) {
				$(this).removeClass('hidden');
				isFull = true;
			}
		});

		if ( isFull == false ) {
			$('.job--no-result').removeClass('hidden');
		}

	}
};

